import styled from "styled-components";

export const SearchInner = styled.div`
   width: 70%;
   display: flex;
   justify-content: center;
`